function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTtBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.929,
    height: 10,
    viewBox: "0 0 15.929 10",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 11775"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 11057",
    d: "M2 8v1.416h2.92V18h1.416V9.416h2.92V8z",
    transform: "translate(-2 -8)",
    style: {
      fill: "#231f20"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 11058",
    d: "M18 8v1.416h2.92V18h1.416V9.416h2.92V8z",
    transform: "translate(-9.327 -8)",
    style: {
      fill: "#231f20"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTtBlack);
export default __webpack_public_path__ + "static/media/TTBlack.b29cf171f7d2c8ea1be8995a134f7ee2.svg";
export { ForwardRef as ReactComponent };